import { render } from "./FolderUnitForm.vue?vue&type=template&id=238ef089"
import script from "./FolderUnitForm.vue?vue&type=script&lang=js"
export * from "./FolderUnitForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__